export default __webpack_public_path__ + "static/media/ThrowCard.e66a2d57.wav";